import { useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import OpsCompanyInfo from './OpsCompanyInfo';
import OpsCompanyStats from './OpsCompanyStats';

import CollapsedCompanyHeader from '@/features/companyDashboard/common/CollapsedCompanyHeader';
import { useCompany } from '@/hooks/useCompany';

const OpsCompanyLayout = () => {
  const { companyId = '' } = useParams();
  const [isCompanyPanelCollapsed, setIsCompanyPanelCollapsed] = useState(false);

  const { companyData, isCompanyLoading } = useCompany(companyId);

  if (isCompanyLoading || !companyData) {
    return null;
  }

  // Content gutter for Members and the members table. The collapsed header sets
  // its own, intentionally narrower, gutter.
  const contentGutter = isCompanyPanelCollapsed ? 'px-20' : 'px-12';

  return (
    <div className="flex-1 gap-0 lg:flex lg:flex-row">
      <OpsCompanyInfo
        company={companyData}
        isCollapsed={isCompanyPanelCollapsed}
        onCollapsedChange={setIsCompanyPanelCollapsed}
      />
      <div className="w-full min-w-0 flex-1 bg-white">
        {isCompanyPanelCollapsed ? (
          <CollapsedCompanyHeader
            company={companyData}
            stats={<OpsCompanyStats isCompact />}
          />
        ) : (
          <div className={contentGutter}>
            <OpsCompanyStats />
          </div>
        )}
        <div className={contentGutter}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default OpsCompanyLayout;
